export default __webpack_public_path__ + "static/media/x.aff0abab.svg";